import type {
  FantasyCalendarDay,
  FantasyCardGrades,
  FantasyDayStatus,
  FantasyGradeFilterValue
} from '~/types/fantasy'

export const mapGradeFilter = (
  grade: FantasyCardGrades | null
): FantasyGradeFilterValue => grade ?? 'all'

export const mapCalendarDayStatus = (
  day: Pick<FantasyCalendarDay, 'can_set_slot' | 'is_completed'>
): FantasyDayStatus => {
  if (day.is_completed) {
    return 'completed'
  }

  if (day.can_set_slot) {
    return 'open'
  }

  return 'in_game'
}
